import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=fa5925b6&scoped=true"
import script from "./OptionGroup.vue?vue&type=script&lang=js"
export * from "./OptionGroup.vue?vue&type=script&lang=js"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&id=fa5925b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5925b6",
  null
  
)

export default component.exports